import React from "react";
import { STATUS_LABELS, STATUS_COLORS } from "@/lib/api";

export default function StatusBadge({ status }) {
  const label = STATUS_LABELS[status] || status;
  const cls = STATUS_COLORS[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${cls}`}
      data-testid={`status-badge-${status}`}
    >
      {label}
    </span>
  );
}
